import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20translucent%20holographic%20shield%20icon%20floating%20above%20an%20open%20laptop%20keyboard%2C%20soft%20glowing%20amber%20light%20emanating%20from%20the%20screen%2C%20warm%20cozy%20evening%20workspace%20atmosphere%2C%20cream%20walls%2C%20wooden%20desk%20with%20a%20steaming%20cup%20of%20tea%2C%20digital%20security%20concept%20rendered%20beautifully%2C%20soft%20diffused%20shadows%2C%20neutral%20warm%20tones%2C%20editorial%20photography%2C%20high%20detail%2C%20trustworthy%20protective%20feeling&width=800&height=600&seq=safety-v2&orientation=landscape"
                alt="Vigorbuy Spreadsheet safety and security"
                className="w-full h-full object-cover object-top rounded-lg"
                title="Vigorbuy Spreadsheet Safety Center"
              />
            </div>
          </div>

          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              Safety Center
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-5">
              Is Vigorbuy Spreadsheet Safe?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Safety is our top priority. We understand that when you are researching products online, you need to trust the information you find. Here is how Vigorbuy Spreadsheet ensures your experience is secure and reliable.
            </p>

            <div className="space-y-3 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900">Verify Information Sources</h4>
                  <p className="text-xs text-foreground-500 mt-0.5">Always cross-check spreadsheet data with official product listings</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900">Avoid Fake Websites</h4>
                  <p className="text-xs text-foreground-500 mt-0.5">Learn to identify legitimate sources and steer clear of imitation platforms</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900">Safe Browsing Practices</h4>
                  <p className="text-xs text-foreground-500 mt-0.5">Follow recommended guidelines for secure online product research</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900">Privacy Protection</h4>
                  <p className="text-xs text-foreground-500 mt-0.5">Understand how your data stays protected during product research</p>
                </div>
              </div>
            </div>

            <Link
              to="/article/vigorbuy-spreadsheet-safety-guide"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shield-check-line"></i>
              Read Safety Guide
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}